import { useImporterViewModel } from '../ImporterViewModel'
import { DetailedImportView } from './DetailedImportView'
import { Operation } from './types'

export function ImportWizardStartImportStep({
  show,
  onImportTags,
  onImportGpos,
  onImportDeals,
  onImportContacts,
  onImportNotes,
  isProcessing,
  currentOperation,
}: {
  show: boolean
  onImportTags: () => void
  onImportGpos: () => void
  onImportDeals: () => void
  onImportContacts: () => void
  onImportNotes: () => void
  isProcessing: boolean
  currentOperation: Operation | null
}) {
  const viewModel = useImporterViewModel()

  if (!show) {
    return null
  }

  return (
    <DetailedImportView
      show={show}
      viewModel={viewModel}
      onImportTags={onImportTags}
      onImportGpos={onImportGpos}
      onImportDeals={onImportDeals}
      onImportContacts={onImportContacts}
      onImportNotes={onImportNotes}
      isProcessing={isProcessing}
      currentOperation={currentOperation}
    />
  )
}
